import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "./components/Navbar";
import { AuthProvider } from "./context/authContext";
import Routes from "./routes";

const GOOGLE_CLIENT_ID =
  "534029500889-cuhutj5ikqfcb3s46j7sgpsv9kag5iu5.apps.googleusercontent.com";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <div className="App">
          <NavBar />
          <Routes />

          <ToastContainer />
        </div>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
